import React, { Component } from "react";
import "./UsuarioModal.css";
import { toast } from "react-toastify";

export default class UsuarioModal extends Component {
  constructor(props) {
    super(props);
    this.state = this.getInitialState(props);
  }

  getInitialState = (props) => {
    const { mode = "create", usuario } = props || {};

    if (mode === "edit" && usuario) {
      return {
        email: usuario?.email ?? "",
        nombre: usuario?.nombre ?? "",
        idtipousuario: String(usuario?.idtipousuario ?? 1),
        idestatus: String(usuario?.idestatus ?? 1),
      };
    }

    return {
      email: "",
      nombre: "",
      idtipousuario: "",
      idestatus: "1",
    };

  };

  componentDidUpdate(prevProps) {
    const openedNow = !prevProps.show && this.props.show;
    const modeChanged = prevProps.mode !== this.props.mode;
    const prevId = prevProps?.usuario?.idusuario;
    const nextId = this.props?.usuario?.idusuario;

    if (openedNow || modeChanged || (this.props.show && prevId !== nextId)) {
      this.setState(this.getInitialState(this.props));
    }
  }

  setField = (k, v) => this.setState({ [k]: v });

  validate = () => {
    const email = String(this.state.email || "").trim();
    const nombre = String(this.state.nombre || "").trim();
    const idtipousuario = Number(this.state.idtipousuario || 0);
    const idestatus = Number(this.state.idestatus || 0);

    if (!email) return { ok: false, message: "Email requerido." };
    const emailOk = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    if (!emailOk) return { ok: false, message: "Email inválido." };

    if (!nombre) return { ok: false, message: "Nombre requerido." };
    if (!idtipousuario) return { ok: false, message: "Tipo de usuario requerido." };
    if (!idestatus) return { ok: false, message: "Estatus requerido." };

    return {
      ok: true,
      payload: { email, nombre, idtipousuario, idestatus },
    };
  };

  onSubmit = () => {
    const r = this.validate();
    if (!r.ok) {
      toast.info(r.message);
      return;
    }
    this.props?.onSave?.(r.payload);
  };

  render() {
    const { show, onClose, loading, mode = "create", roles = [] } = this.props;
    const { email, nombre, idtipousuario, idestatus } = this.state;

    if (!show) return null;

    return (
      <div className="pm-backdrop">
        <div className="pm-modal" onClick={(e) => e.stopPropagation()}>
          <div className="pm-head">
            <h3 className="pm-title">{mode === "edit" ? "Editar usuario" : "Agregar usuario"}</h3>
            <button className="pm-x" onClick={loading ? null : onClose} aria-label="Cerrar">
              ✕
            </button>
          </div>

          <div className="pm-body">
            <div className="pm-field">
              <label>Email *</label>
              <input
                value={email}
                onChange={(e) => this.setField("email", e.target.value)}
                placeholder="user@test.com"
                disabled={loading}
              />
            </div>

            <div className="pm-field">
              <label>Nombre *</label>
              <input
                value={nombre}
                onChange={(e) => this.setField("nombre", e.target.value)}
                placeholder="Juan Perez"
                disabled={loading}
              />
            </div>

            <div className="pm-field">
              <label>Tipo de usuario *</label>
              <select
                className="um-select"
                value={idtipousuario}
                onChange={(e) => this.setField("idtipousuario", e.target.value)}
                disabled={loading}
              >
                {/* Placeholder opcional */}
                <option value="" disabled>
                  Selecciona un tipo...
                </option>

                {(Array.isArray(roles) ? roles : []).map((r) => (
                  <option key={r.idtipousuario} value={String(r.idtipousuario)}>
                    {r.tipo}
                  </option>
                ))}
              </select>

            </div>

            <div className="pm-field">
              <label>Estatus *</label>
              <select
                className="um-select"
                value={idestatus}
                onChange={(e) => this.setField("idestatus", e.target.value)}
                disabled={loading}
              >
                <option value="1">Activo</option>
                <option value="2">Inactivo</option>
              </select>
            </div>
          </div>

          <div className="pm-foot pm-footCenter">
            <button className="pm-btn ghost" onClick={onClose} disabled={loading}>
              CANCELAR
            </button>
            <button className="pm-btn" onClick={this.onSubmit} disabled={loading}>
              {mode === "edit" ? "ACTUALIZAR" : "ACEPTAR"}
            </button>
          </div>
        </div>
      </div>
    );
  }
}
